<template>
<div>
  <v-card class="progress-container" v-if="initialLoading">
    <v-progress-circular :size="120" color="primary" indeterminate></v-progress-circular>
  </v-card>
  <div v-else>
    <div style="margin-bottom: 2rem" v-if="$store.state.forms.schema.type == schemaType.TEST">
      <h2> {{$t('test.score')}} : {{ records[0].score >= $store.state.forms.schema.min_score ? $t('test.passed') : $t('test.failed') }} </h2>
    </div>
    <v-data-table :headers="headers" :items="records" :loading="updateLoading"
                  :no-data-text="tableTranslations.noDataText" :no-results-text="tableTranslations.noResultsText"
                  :rows-per-page-text="tableTranslations.rowsPerPageText"
                  :total-items="1"
      class="elevation-1">
      <template slot="headers" slot-scope="props">
        <tr>
          <th class="narrow-header">
            <span class="span-blcok"> ID </span>
          </th>
          <th v-for="(header,index) in props.headers" :key="header.text+'_'+index" class="text-overflow header">
            <span class="span-blcok"> {{ header.text }} </span>
            <v-tooltip top v-if="hasDescription(header.value)">
              <template v-slot:activator="{ on :  on }">
                <v-icon style="margin: -1px 5px;" class="center" color="blue darken-3" small v-on="on">info</v-icon>
              </template>
              <span>{{ formField(header.value).description }}</span>
            </v-tooltip>
          </th>
        </tr>
      </template>
      <template slot="items" slot-scope="props">
        <tr :class="{ 'unconfirmed': !isConfirmed(props.item) }" @dblclick="confirmForm(props.item)">
          <td :class="{ 'unvalidate': !isValidate(props.item, header.value) }" class="text-overflow" v-for="(header, index) in formHeaders" :key="index">

            <table-view :context="createContext(props.item)" v-if="header.type === fieldType.TABLE" :table="formField(header.value)" :form_id="props.item.id" :rows_amount="props.item[header.value].data" @loading="updateLoading = $event" />

            <div v-else-if="header.type === fieldType.PERMAMENT">{{ props.item[header.value] }}</div>

            <div v-else-if="header.type === fieldType.SIGNATURE">
              <img v-if="props.item[header.value].data != null && props.item[header.value].data.length >10 " @click="openImage(props.item[header.value].data,'image/png')" class="imageField"
                :src="'data:image/png;base64,'+props.item[header.value].data" />
              <div v v-else>Brak</div>
            </div>

            <div v-else-if="header.type === fieldType.PHOTO">
              <img v-if="props.item[header.value].data != null && props.item[header.value].data.length >10 " @click="openImage(props.item[header.value].data,'image/jpg')" class="imageField"
                :src="'data:image/jpg;base64,'+props.item[header.value].data" />
              <div v-else>Brak</div>
            </div>

            <div v-else-if='header.type === fieldType.ARCHIVE'>
              <Archive v-if="props.item[header.value].data != null " :edit="editable" :archive="props.item[header.value].data" />
              <div v-else>Brak</div>
            </div>


            <div v-else-if='header.type === fieldType.RELATED '>
              <Related :code="props.item[header.value].data" :field="getSchemaField(header.value)" />
            </div>

            <div v-else-if='header.type === fieldType.DEPEND '>
              <Depend :code="props.item[header.value].data" :field="getSchemaField(header.value)" />
            </div>

            <div v-else-if="header.type === fieldType.CONFIRMATION">
              <v-tooltip v-if="isConfirmed(props.item)" top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-icon class="light-green--text">check_circle_outline</v-icon> {{ props.item[header.value].confirmed_by }}
                  </span>
                </template>
                <span>{{ props.item[header.value].confirmed_at }}</span>
              </v-tooltip>
              <v-icon v-else @click="confirmForm(props.item)" class="red--text pointer">highlight_off</v-icon>
            </div>

            <div v-else-if='header.type === fieldType.CHECKBOX'>
              <Checkbox :context="createContext(props.item)" :formData="props.item" :field=getSchemaField(header.value) :valueField="props.item[header.value].data" :validation="props.item[header.value].validation" />
            </div>

            <div v-else-if='header.type === fieldType.RADIO'>
              <Radio :context="createContext(props.item)" :formData="props.item" :editable="editable" :field=getSchemaField(header.value) :valueField="props.item[header.value].data" :validation="props.item[header.value].validation" />
            </div>
            <div v-else>
              <CustomField :context="createContext(props.item)" :formData="props.item" :editable="editable" :field=getSchemaField(header.value) :valueField="props.item[header.value].data" :validation="props.item[header.value].validation">
              </CustomField>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</div>
</template>

<script>
import fieldType from '@/enums/fieldType'
import states from '@/enums/states'
import TableView from './view/TableView'
import FormStats from "../stats/FormStats"
import FilterView from './view/FilterView'
import CustomField from './view/CustomField'
import Checkbox from './view/Checkbox'
import Radio from './view/Radio'
import Archive from "./view/Archive"
import Related from "./view/Related"
import Depend from "./view/Depend"
import State from "./State"
import FormAdapter from '@/plugins/FormAdapter'
import Context from '@/plugins/Context'
import Upload from './Upload'
import schemaType from "@/enums/schemaType"

export default {
  props: ['schemaId', 'formId'],
  components: {
    FormStats,
    TableView,
    FilterView,
    CustomField,
    Archive,
    Related,
    Depend,
    State,
    Checkbox,
    Radio,
    Upload
  },
  data() {
    return {
      showSummary: false,
      editable: false,
      byUser: false,
      searchPhrase: "",
      dateFrom: "",
      dateTo: "",
      state: 1,
      menuFrom: false,
      menuTo: false,
      initialLoading: true,
      updateLoading: false,
      templates: [],
      template: null,
      format: 'PDF',
      fieldsCondition: {},
      summaryFields: {},
      states: states,
      Context,
      schemaType
    }
  },
  computed: {
    tableTranslations() {
      return this.$store.getters.tableTranslations
    },
    fields() {
      return this.$store.state.forms.schema.fields
    },
    formHeaders() {
      let adapter = new FormAdapter(this.$store.state.forms.schema);
      return adapter.getHeaders();

    },
    headers() {
      return this.formHeaders.slice(1) //delete id header, ii is added manualy

    },
    records() {
      let schema = this.$store.state.forms.schema
      let adapter = new FormAdapter(schema);
      adapter.loadForms(this.$store.state.forms.results)
      return adapter.getRecords();
    },
    fieldType() {
      return fieldType
    },
    confirmation() {
      let firstRecord = this.records.find(() => true)
      if (firstRecord) {
        return firstRecord.hasOwnProperty('confirmation')
      }
      return false
    },
    pagination: {
      get: function() {
        return this.$store.state.formPagination
      },
      set: function(value) {
        this.$store.commit('setFormPagination', value)
      }
    },
    itemTrigger() {
      return [this.pagination, this.dateFrom, this.dateTo]
    }
  },
  watch: {
    itemTrigger() {
      if (!this.initialLoading) {
        this.updateLoading = true
        this.queryForms()
          .then(() => {
            this.updateLoading = false
          })
      }
    }
  },
  created() {
    this.initialLoading = true
    Promise.all([
      this.queryForms(),
      this.$store.dispatch('loadRelatedSchemas')
    ]).then(() => {
      this.initialLoading = false
    })
  },
  methods: {
    isValidate(result, order) {
      if (result[order] != undefined && result[order].validation != undefined && order >= 1)
        return result[order].validation.pass

      return true;
    },
    createContext(records) {
      return Context.createFullFormContext(this.fields, records)
    },
    getSchemaField(order) {
      return this.$store.state.forms.schema.fields.find(field => field.order == order)
    },
    isConfirmed(record) {
      if (this.confirmation) {
        return record.confirmation.hasOwnProperty('confirmed_by') && record.confirmation.confirmed_by !== null
      }
      return true
    },
    queryForms() {
      return this.$store.dispatch('loadSingleForm', {
        schema_id: this.schemaId == null ? this.$route.params.schemaId : this.schemaId,
        form_id: this.formId == null ? this.$route.params.formId : this.formId
      })
    },
    formField(order) {
      return this.$store.getters.formField(order)
    },
    hasDescription(filedOrder) {
      let field = this.formField(filedOrder)

      if (field != undefined && field.description != null && field.description.length > 0)
        return true
    },
    openImage(base64, type) {
      let win = window.open("")
      win.document.write('<img  src=\'data:' + type + ";base64," + encodeURI(base64) + "'></img>");
    }
  },
}
</script>

<style scoped>
.unconfirmed {
  background: repeating-linear-gradient(45deg,
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0.1) 10px,
      rgba(0, 0, 0, 0.15) 10px,
      rgba(0, 0, 0, 0.15) 20px);
}

.unvalidate {
  background-color: #ff4d4d !important;
}

.incorrect {
  text-decoration: underline red;
}

.progress-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
}

.imageField {
  height: 100px;
}

.text-overflow {
  text-align: center;
  word-wrap: break-word;
  align: center;
  vertical-align: middle;

}

.center {
  margin: 0 auto;
}

.span-blcok {
  display: inline-block;
  height: 50px;
  white-space: normal;
}

.header {
  width: 200px
}

.narrow-header {
  width: 70px;
}

.marrgin-stats {
  margin-top: 20px;
}

.active {
  background-color: #ccffcc !important;
}
</style>
